export default __webpack_public_path__ + "static/media/earning.16f96a09.svg";